import React from 'react'
import page_title_image from "../assets/images/bg/page-title-bg.png"

const PageTitle = ({title}) => {
  return (
    <section
      className="page-title"
      style={{ backgroundImage: `url(${page_title_image})` }}
    >
      <div className="auto-container">
        <div className="title-outer">
          <h1 className="title">
            {title}
          </h1>
        </div>
      </div>
    </section>
  );
}

export default PageTitle